import src from "IMAGE";
export default { src, width: 221, height: 129, blurWidth: 0, blurHeight: 0};
